import IconButton from '@mui/material/IconButton'
import Stack from '@mui/material/Stack'
import Paper from '@mui/material/Paper'
import React from 'react'
import RefreshIcon from '@mui/icons-material/Refresh'

type Props = {
  onRefresh?: () => void
}

export function RefreshButton({ onRefresh }: Props) {
  return (
    <Paper elevation={4}>
      <Stack>
        <IconButton sx={{ p: 1 }} onClick={onRefresh}>
          <RefreshIcon fontSize="small" />
        </IconButton>
      </Stack>
    </Paper>
  )
}
